import { Component, OnInit } from '@angular/core';
import { DomainNameParserService } from '../../services/domain-name-parser.service';

@Component({
  selector: 'app-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.css']
})
export class LoginHeaderComponent implements OnInit {

  stylingScheme: string;

  constructor(private domainNameParserService: DomainNameParserService) {
    this.stylingScheme = this.domainNameParserService.getState();
  }

  ngOnInit(): void {
  }

}
